import React from 'react';
import Hauptseite from './Hauptseite';

function App() {
  return <Hauptseite />;
}

export default App;